import { Pipe, PipeTransform } from '@angular/core';
import { stripeInvoiceStatus } from '../data/stripeInvoiceStatus';

@Pipe({
	name: 'stripeInvoiceStatus',
	standalone: false,
})
export class InvoiceStatusPipe implements PipeTransform {
	transform(value: string): stripeInvoiceStatus | string {
		const xform: stripeInvoiceStatus =
			stripeInvoiceStatus[value as stripeInvoiceStatus];

		return xform || value;
	}
}
